<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{
  value?: number
  class?: string
}>()

const formattedAmount = computed(() => {
  return props.value?.toLocaleString('nb-NO', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
})
</script>
<template>
  <span v-if="value === undefined" :class="props.class">
    <span>-</span>
  </span>
  <span v-else :class="props.class">
    <span>{{ formattedAmount }}</span>
  </span>
</template>
